import { createContext } from 'react';

// Defined locally rather than imported from ui-components
// `useScopedTranslations` because the legacy consumers of this context
// (`useTranslations`) do not use that hook. Coupling the type to the
// scoped-translations primitive would imply a dependency that does not
// exist in legacy code.
export const AuthedI18nContext = /*#__PURE__*/createContext({
  i18nLoader: null
});
export const PublicI18nContext = /*#__PURE__*/createContext({
  i18nLoader: null
});